import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Report } from 'types/reports';

interface ReportsPayload extends Omit<PayloadAction, 'payload'> {
  payload: { reports: Report[] };
}

interface ReportPayload extends Omit<PayloadAction, 'payload'> {
  payload: { report: Report };
}

const initialValue: Report[] = [];

export const reportsSlice = createSlice({
  name: 'reports',
  initialState: {
    value: initialValue,
  },
  reducers: {
    add: (state, action: ReportPayload) => {
      const { report } = action.payload;
      state.value = [
        ...state.value,
        {
          id: report.id,
          description: report.description,
          contact: report.contact,
          latlng: report.latlng,
          priority: report.priority,
        },
      ];
    },
    change: (state, action: ReportPayload) => {
      const { report } = action.payload;
      state.value = state.value.map((r) => {
        if (r.id === report.id) {
          return report;
        } else {
          return r;
        }
      });
    },
    remove: (state, action: { payload: { id: string } }) => {
      const { id } = action.payload;
      state.value = state.value.filter((r) => r.id !== id);
    },
    replace: (state, action: ReportsPayload) => {
      state.value = action.payload.reports;
    },
  },
});

// Action creators are generated for each case reducer function
export const { add, change, remove, replace } = reportsSlice.actions;
export const selectAllReports = (state) => state.reports;

export default reportsSlice.reducer;
